import Organizations_Sessions_SessionExpiredPage from "@Organizations/Sessions/Pages/SessionExpiredPage.vue";

export const routes = [
    {
        path: "/organizations/sessions/expired/:returnUrl?",
        component: Organizations_Sessions_SessionExpiredPage
    }
]
